import { ACTIVE_INFO_PANEL, PASSIVE_INFO_PANEL } from '../actions/actionTypes';

const initialState = null;

const infoPanelReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTIVE_INFO_PANEL:
      return payload;
    case PASSIVE_INFO_PANEL:
      return null;
    default:
      return state;
  }
};

export default infoPanelReducer;
